import { EMPTY_CONSENT } from "constants/categories";
import { IConsent } from "types/consent";
import type WidgetConfig from "helpers/init/WidgetConfig";
import isServiceAccepted from "./isServiceAccepted";

const makeGranularConsentObject = (
  consent: IConsent,
  widgetConfig: WidgetConfig
): IConsent => {
  const granularConsent = widgetConfig.scripts.reduce<IConsent>(
    (aggregate, script) => {
      return {
        ...aggregate,
        [script.consent_key]: isServiceAccepted(
          script,
          consent,
          widgetConfig.consentPolicy
        ),
      };
    },
    { ...EMPTY_CONSENT }
  );

  return granularConsent;
};

export default makeGranularConsentObject;
